import React, { useState } from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import { useNavigate } from 'react-router-dom';
import { showToast } from '../../../Components/Utlis/toastUtlis';
import { ApiService } from '../../../Components/Services/apiServices';

const Demo = () => {

  const [demoFormdata, setDemoFormdata] = useState({
    name: '',
    email: '',
    organisation_name: '',
    company_size: '',
    mobile: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setDemoFormdata({
      ...demoFormdata,
      [e.target.name]: e.target.value,
    });
  };

  const handleDemo = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!demoFormdata.name) {
      showToast("error", "Please Enter Your Full Name");
      setLoading(false);
      return false;
    }
    if (!demoFormdata.email) {
      showToast("error", "Please Enter Your Email");
      setLoading(false);
      return false;
    }
    if (!demoFormdata.organisation_name) {
      showToast("error", "Please Enter Your Organisation Name");
      setLoading(false);
      return false;
    }
    if (!demoFormdata.company_size) {
      showToast("error", "Please Choose Your Company Size");
      setLoading(false);
      return false;
    }
    if (!demoFormdata.mobile) {
      showToast("error", "Please Enter Your Mobile");
      setLoading(false);
      return false;
    }
    if (!demoFormdata.message) {
      showToast("error", "Please Enter Your Message");
      setLoading(false);
      return false;
    }

    try {
      const demoData = await ApiService.Commanpostrequest("demo", demoFormdata);
      if (demoData.success) {
        showToast("success", "Demo Request Submitted Successfully!");
        setDemoFormdata({
          name: '',
          email: '',
          organisation_name: '',
          company_size: '',
          mobile: '',
          message: ''
        })

      } else {
        showToast("error", "Demo request failed. Please try again.")

      }
    } catch (error) {
      console.error("Registration error: ", error)
      showToast("error", "An error occurred. Please try again later.")
    } finally {
      setLoading(false);
    }

  }

  return (
    <>
      <Header />
      <section>
        <div className="container-fluid">
          <div className="user signinBx">
            {/* Image Section */}
            <div className="imgBx">
              <img src="https://sigohrmlpadmin.loopring.in/front/images/hero-services-img.webp" className="img-fluid hero-img" alt="img" />
            </div>
            {/* Form Section */}
            <div className="formBx">
              <h2 className='text-center' style={{ fontSize: '28px', color: 'green', fontWeight: '700' }}>Request For Demo</h2>
              <form onSubmit={handleDemo}>
                <div className="row">
                  <div className="col-lg-6">
                    <label htmlFor="name">Full Name <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" name="name"
                      placeholder="Enter your full name"
                      onChange={handleChange}
                      value={demoFormdata.name}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="email">Email Address <span style={{ color: 'red' }}>*</span></label>
                    <input type="email" name="email"
                      placeholder="Enter your organization email address"
                      onChange={handleChange}
                      value={demoFormdata.email}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="organisation_name">Organisation Name <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" name="organisation_name"
                      placeholder="Enter your organisation name"
                      onChange={handleChange}
                      value={demoFormdata.organisation_name}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="company_size">Company Size <span style={{ color: 'red' }}>*</span></label>
                    <div className="d-flex">
                      <select name="company_size" className="form-select me-2"
                      value={demoFormdata.company_size}
                      onChange={handleChange}
                      >
                        <option value="" disabled selected>Choose Company Size</option>
                        <option value="1-50">1-50</option>
                        <option value="50-100">50-100</option>
                        <option value="100-200+">100-200+</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 w-100">
                    <label htmlFor="mobile">Phone Number <span style={{ color: 'red' }}>*</span></label>
                    <div className="d-flex">
                      <select className="form-select w-25 me-2">
                        <option>+91</option>
                        <option>+11</option>
                        <option>+91</option>
                      </select>
                      <input type="phone" name="mobile" className="form-control w-75"
                        onChange={handleChange}
                        value={demoFormdata.mobile}
                        placeholder="Enter phone number" />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="message">Message or any Information <span style={{ color: 'red' }}>*</span></label>
                    <textarea rows={2} name="message"
                      onChange={handleChange}
                      value={demoFormdata.message}
                      placeholder="Enter message here" style={{ width: 255 }} defaultValue={""} />
                  </div>
                </div>
                <button className="btn btn-success w-100 mt-3"  type="submit"  disabled={loading}>
                  {loading ? 'Loading...' : 'Request demo'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default Demo
